<template>
  <div>
    <!-- <WidgetsDropdown/> -->
    <CCard>
      <CCardBody>
        <loading :active.sync="isLoading"
        :can-cancel="false" :is-full-page="fullPage"></loading>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">Welcome {{userName}}</h4>
          </CCol>
        </CRow>
        <!-- <MainChartExample style="height:300px;margin-top:40px;"/> -->
      </CCardBody>
      <CCardFooter>
        <CRow class="text-center">
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Active users</div>
            <strong>{{this.resources.activeUsers}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Inactive users</div>
            <strong>{{this.resources.inActiveUsers}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Verified users</div>
            <strong>{{this.resources.verifiedUsers}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="info"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Unverified users</div>
            <strong>{{this.resources.unVerifiedUsers}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="warning"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Total created adverts</div>
            <strong>{{this.resources.totalCreatedAdverts}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="danger"
              :value="100"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Total active adverts</div>
            <strong>{{this.resources.totalActiveAdverts}}</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              :value="100"
            />
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
    <!-- <WidgetsBrand/> -->
  </div>
</template>

<script>
import axios from 'axios';
import VueNotifications from 'vue-notifications'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Dashboard',
  data () {
    return {
      showAddBtn: true,
      isLoading: false,
      fullPage: true,
      resources: [],
      userName: JSON.parse(localStorage.getItem('userdata')).email,
      API_URL: API_URL,
      APP_URL: APP_URL,
      API_ADMIN_URL: API_ADMIN_URL,
      tokenChange: JSON.parse(localStorage.getItem('token')),
      // selected: 'Month',
      // tableItems: [
      //   {
      //     avatar: { url: 'img/avatars/1.jpg', status: 'success' },
      //     user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'USA', flag: 'cif-us' },
      //     usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
      //     activity: '10 sec ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
      //     user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
      //     country: { name: 'Brazil', flag: 'cif-br' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Visa', icon: 'cib-cc-visa' },
      //     activity: '5 minutes ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
      //     user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'India', flag: 'cif-in' },
      //     usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Stripe', icon: 'cib-stripe' },
      //     activity: '1 hour ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/4.jpg', status: '' },
      //     user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'France', flag: 'cif-fr' },
      //     usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'PayPal', icon: 'cib-paypal' },
      //     activity: 'Last month'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/5.jpg', status: 'success' },
      //     user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Spain', flag: 'cif-es' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
      //     activity: 'Last week'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
      //     user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Poland', flag: 'cif-pl' },
      //     usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Amex', icon: 'cib-cc-amex' },
      //     activity: 'Last week'
      //   }
      // ],
      // tableFields: [
      //   { key: 'avatar', label: '', _classes: 'text-center' },
      //   { key: 'user' },
      //   { key: 'country', _classes: 'text-center' },
      //   { key: 'usage' },
      //   { key: 'payment', label: 'Payment method', _classes: 'text-center' },
      //   { key: 'activity' },
      // ]
    }
  },
  components: {
      Loading
  },
  created() {
    document.title = "Dashboard";
    this.checkLoggedIn();
    this.loadData();
  },
  methods: {
    loadData() {
        this.isLoading = true;
        axios.post(`${API_ADMIN_URL}/adminStatistics`, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
            if (response.data.status == 200) {
                this.resources = response.data.data;
                this.isLoading = false;
            } else {
                this.isLoading = false;
                localStorage.clear();
                this.$router.push('/login');
            }
        });
    },
    checkLoggedIn() {
        if (localStorage.getItem('token') == null || localStorage.getItem('token') == "") {
            localStorage.removeItem('token');
            localStorage.removeItem('userdata');
            this.$router.push("/login");
        }
    }
  }
}
</script>
